import React from 'react';
import { Card, CardContent } from '@/Components/ui/card';
import { Button } from '@/Components/ui/button';
import { Heading, Text } from '@/Components/ui/typography';
import { Stack, Inline } from '@/Components/ui/layout';
import { FileText, Download } from 'lucide-react';

function ResumeDownload() {
  return (
    <Card className="rounded-lg border-[1.5px] border-blue-100 bg-white flex mt-6 w-full max-w-[312px] flex-col p-6">
      <CardContent className="p-0">
        <Heading level="h2" size="base" className="font-medium text-slate-900 m-0">
          Download My Resume
        </Heading>
        <div className="rounded-lg flex mt-4 w-full max-w-[264px] items-center justify-between">
          <Inline spacing="sm" className="items-center gap-3">
            <FileText className="w-12 h-12 text-slate-600" />
            <Stack spacing="xs">
              <Text size="xs" className="text-slate-500 font-normal">
                Esther Howard
              </Text>
              <Text size="sm" className="text-slate-900 font-medium leading-none mt-1">
                PDF
              </Text>
            </Stack>
          </Inline>
          <Button variant="ghost" size="icon" className="w-12 h-12 rounded bg-blue-50" aria-label="Download Resume">
            <Download className="w-6 h-6" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}

export default ResumeDownload;